import { useEffect, useState } from "react";
import Pagination from "../Layout/Pagination";
import SearchExportComponent from "../Layout/SearchExportComponent";
import TableLayout from "../Layout/TableLayout";
import EditUser from "./EditUser";
import { getManageUser } from "../../actions/ManageUserAction";
import { getAllUsers } from "../../services/manageUserService";
import { getExportData } from "../../Common/functions";

const ManageUserOverview = (
  {
    // data,
    // currentPage,
    // totalPages,
    // totalCount,
    // setCurrentPage,
    // setSearchTerm,
    // itemsPerPage,
    // setItemsPerPage,
  }
) => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [openEditDetailBox, setOpenEditDetailBox] = useState(false);
  const [selectedObject, setSelectedObject] = useState([]);
  const [visibleHeaders, setVisibleHeaders] = useState([
    "profile",
    "username",
    "phone_number",
    "email",
    "GroupName",
  ]);
  const tableHeaders = [
    { label: "Profile", value: "profile" },
    { label: "Username", value: "username" },
    { label: "Phone number", value: "phone_number" },
    { label: "Email Address", value: "email" },
    { label: "Group Name", value: "GroupName" },
    // { label: "Doctor", value: "doctorsname" },
    // { label: "Patient Name", value: "patientname" },
    // { label: "Patient Email", value: "patientemail" },
    // { label: "Product Group", value: "product_group" },
    // { label: "Category", value: "category" },
    // { label: "UnitPrice", value: "unit_price" },
    // { label: "Quantity", value: "quantity" },
    // { label: "Value", value: "value" },
    // { label: "Status", value: "tracking_status" },
    // { label: "Sales Order_Status", value: "sales_order_status" },
    // { label: "Action", value: "action", isEdit: true },
    // { label: "Date", value: "timestamp" },
  ];
  const handleSearch = (term) => setSearchTerm(term);
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => setCurrentPage(page);
  const handleExport = () => console.log("Exporting data:", data);
  const handleEditAction = (item) => {
    console.log("edit");
    console.log("item", item);
    setSelectedObject(item);
    setOpenEditDetailBox(true);
  };

  const fetchData = async () => {
    const response = await getManageUser(searchTerm, currentPage, itemsPerPage);
    console.log("response", response);
    if (response.success) {
      setData(response.data);
      setCurrentPage(response.currentPage);
      setTotalCount(response.totalCount);
      setTotalPages(response.totalPages);
    }
  };
  useEffect(() => {
    // fetchData();
  }, [currentPage, itemsPerPage, searchTerm]);

  function getTotalPages(totalItems, itemsPerPage) {
    if (itemsPerPage <= 0) return 0; // avoid division by zero
    return Math.ceil(totalItems / itemsPerPage);
  }

  const getSalesDetails = async () => {
    setData([]);
    let result = [];
    result = await getAllUsers({
      page_size: itemsPerPage,
      page_number: currentPage,
      search_term: searchTerm,
    });
    setData(result.data.items);
    setCurrentPage(result.data.current_page);
    setTotalCount(result.data.totalCount);
    setTotalPages(getTotalPages(result.data.totalCount, itemsPerPage));
  };

  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    } else {
      getSalesDetails();
    }
  }, [searchTerm]);

  useEffect(() => {
    getSalesDetails();
  }, [itemsPerPage, currentPage]);

  const exportData = getExportData(data, tableHeaders, visibleHeaders);

  return (
    <div className="px-0 sm:px-4 py-6 ">
      <SearchExportComponent
        exportFileName="ManageUser"
        onSearch={handleSearch}
        onExport={handleExport}
        // searchPlaceholder="Search"
        tablefields={tableHeaders}
        selectedHeaders={visibleHeaders}
        onHeadersChange={setVisibleHeaders}
        FilterOptionVisisbility={false}
        exportData={exportData}
      />
      <TableLayout
        data={data}
        headers={tableHeaders.filter((header) =>
          visibleHeaders.includes(header.value)
        )}
        handleAction={handleEditAction}
      />
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={handlePageChange}
        itemsPerPage={itemsPerPage}
        onItemsPerPageChange={handleItemsPerPageChange}
      />

      {openEditDetailBox && (
        <EditUser
          closeModal={() => setOpenEditDetailBox(false)}
          selectedObject={selectedObject}
        />
      )}
    </div>
  );
};

export default ManageUserOverview;
